import { useParams } from 'react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import InstagramEmbedComponent from '../../components/InstagramEmbedComponent';
import useNewsList from '../../hooks/useNewsList';
import ReactMarkdown from 'react-markdown';
import Preloader from '../../components/Preloader';
import { findNewsBySlug } from '../../utils/petSlug';

function NewsDetail() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language; // "bs" ili "en"
  const { newsSlug } = useParams();

  const { data: newsPosts = [], isLoading, isError } = useNewsList();

  // Dohvati vijest po slug-u
  const post = useMemo(
    () => findNewsBySlug(newsSlug, newsPosts, lang),
    [newsPosts, newsSlug, lang]
  );

  if (isLoading) {
    return (
      <div className="page" style={{ padding: '50px 0', textAlign: 'center' }}>
        <Preloader />
      </div>
    );
  }

  if (isError) {
    return (
      <div
        className="page"
        style={{ padding: '50px 0', textAlign: 'center', color: 'red' }}
      >
        {t('newsPage.notFound')}
      </div>
    );
  }

  if (!post) {
    return (
      <div className="page">
        <h2>{t('newsPage.notFound')}</h2>
      </div>
    );
  }

  // Formatiranje datuma
  const months = {
    bs: [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar',
    ],
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  };
  const dateObj = new Date(post.date); // post.date je string
  const formattedDate = `${months[lang][dateObj.getMonth()]} ${dateObj.getDate()}, ${dateObj.getFullYear()}`;

  // Dinamični tekstovi
  const title = post[`title_${lang}`] || post.title_en;
  const excerpt = post[`excerpt_${lang}`] || post.excerpt_en;
  const content = post[`content_${lang}`] || post.content_en;

  return (
    <div id="top">
      <PageHeader
        title={t('newsPage.title')}
        page={t('newsPage.page')}
        pageUrl={`news`}
        subPage={title}
      />
      <div className="page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-xl-9 card blog-card">
              <div className="card-body">
                <h3 className="card-title">{title}</h3>
                <div className="post-info border-irregular2 text-muted">
                  {' '}
                  {formattedDate}
                </div>
                <hr />
                {post.img && (
                  <img src={post.img} className="img-fluid mb-3" alt={title} />
                )}
                  <p className="lead">{excerpt}</p>
                <ReactMarkdown
                  components={{
                    a: ({ node, ...props }) => (
                      <a {...props} target="_blank" rel="noopener noreferrer" />
                    ),
                  }}
                >
                  {content}
                </ReactMarkdown>
                {post.instagramPostId && (
                  <InstagramEmbedComponent postId={post.instagramPostId} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NewsDetail;
